import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import {
    Box,
    Button,
} from '@material-ui/core';
import { BASE_URL } from '../../../store/config';
import instance from '../../../request/http'
import Toast from '../../Layout/components/Toast';
import AddIcon from '@material-ui/icons/AddCircleOutline';
import { clone } from '../../../common/utils';
import ContactInfo from './ContactInfo';
import { ADD, EDIT } from '../../../common/common';

const Root = styled(Box)({
    width: '100%',
    '& .table': {
        width: '100%',
        borderCollapse: 'collapse',
        border: '1px solid #D8D8D8',
        '& th': {
            backgroundColor: '#EDEDED',
            border: '1px solid #D8D8D8'
        },
        '& td': {
            backgroundColor: '#FDFBFE',
            border: '1px solid #D8D8D8'
        },
        '& .textFieldAuto': {
            width: '100px',
        },
        '& .noBorder': {
            border: 'none',
        },
        '& .final': {
            backgroundColor: '#E3EFF7',
            color: '#142D33',
            fontWeight: 'bold',
        },
        '& .finalReport': {
            fontSize: '24px',
        },
        '& .addBtn': {
            verticalAlign: 'top',
        },
        '& .bgTransparent': {
            backgroundColor: 'transparent',
        },
        '& Button': {
            backgroundColor: '#fff',
        },
        '& .editRate': {
            cursor: 'pointer',
        },
        '& .alias-name': {
            background: '#005e96',
            fontSize: '10px',
            fontWeight: 'bold',
            padding: '2px 8px',
            borderRadius: '15px',
            color: '#ffffff',
        }
    },
})

class Contacts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contactsData: [
                // {
                //     // client_id: 1,//公司 选择的才填
                //     // other_client_id: 1,//个人 选择的才填
                //     first_name: "gou",
                //     last_name: "bi",
                //     full_name: "gou bi",
                //     relation: "ceo",
                //     email: "12345678@qq.com",
                //     phone: "13322223333",
                //     wechat: "goubijiushini",
                //     note: "ss",
                // }
            ],
            showList: false,
            isAdd: false,
            crtContact: null,
            crtIndex: null,
            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.closeContact = this.closeContact.bind(this);
        this.handleAddPoints = this.handleAddPoints.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }

    render() {
        const { disabled } = this.props;
        const {
            contactsData,
            showList,
            crtContact,
            isAdd,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        return (
            <Root>
                <table className="table" cellPadding={10}>
                    <thead>
                        <tr>
                            <th width="15%">Name</th>
                            <th width="5%">Title</th>
                            <th width="15%">Email</th>
                            <th width="15%">Phone</th>
                            <th width="20%">Wechat</th>
                            <th width="30%" style={{ minWidth: '140px', display: disabled ? "none" : "" }}>Others</th>
                        </tr>
                    </thead>
                    <tbody>
                        {contactsData.map((row, index) => (
                            <tr key={index}>
                                <td align="center">{row.client.first_name + " " + row.client.last_name}</td>
                                <td align="center">{row.relation}</td>
                                <td align="center">{row.client.email}</td>
                                <td align="center">{row.client.phone}</td>
                                <td align="center">{row.client.wechat}</td>
                                <td align="center" style={{ display: disabled ? "none" : "" }}>
                                    <div>
                                        <Button size="small" variant="outlined" color="primary"
                                            style={{ marginRight: '10px' }}
                                            onClick={e => this.handleEdit(e, row, index)}>Edit</Button>
                                        <Button size="small" variant="outlined" color="secondary"
                                            onClick={e => this.handleDel(e, row, index)}>Delete</Button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <ContactInfo
                    open={showList}
                    isAdd={isAdd}
                    data={crtContact}
                    onClose={this.closeContact}
                ></ContactInfo>
                <Button style={{ display: disabled ? "none" : "" }} color="primary" onClick={this.handleAddPoints}>
                    <AddIcon></AddIcon>
                    Add More Contacts
                </Button>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }

    componentDidMount() {
        const { data } = this.props;
        this.setState({
            contactsData: data || []
        })
    }

    componentDidUpdate(prevProps) {
        const {
            data
        } = this.props;
        if (prevProps.data !== data) {
            if (data) {
                if (!data) return;
                let contactsData = [];
                if (data.length > 0) {
                    for (const obj of data) {
                        if (obj.client) {
                            console.log("dddddddddddddddddd", obj.client)
                            const individualInfo = obj.client.individual;
                            let contactObj = {
                                contact_id: obj.id,//公司 选择的才填
                                client_id: obj.client.client_id,//公司 选择的才填
                                client: {
                                    first_name: individualInfo.first_name,
                                    last_name: individualInfo.last_name,
                                    full_name: individualInfo.first_name + " " + individualInfo.last_name,
                                    email: individualInfo.email,
                                    phone: individualInfo.phone,
                                    wechat: individualInfo.wechat,
                                },
                                relation: obj.relation,
                            };
                            contactsData.push(contactObj);
                        }
                    }
                }
                this.setState({
                    contactsData
                })
            }
        }
    }

    initData() {
    }

    handleEdit(e, row, index) {
        console.log(index, row);
        this.setState({
            showList: true,
            isAdd: false,
            crtContact: {
                index: index,
                contact_id: row.contact_id,
                client_id: row.client_id,
                client: row.client,
                relation: row.relation,
            },
        });
    }

    handleDel(e, row, index) {
        const contactId = row.contact_id;
        const contactsData = clone(this.state.contactsData);
        if (contactId) {
            this.delContact(contactId, () => {
                contactsData.splice(index, 1);
                this.setState(() => ({
                    contactsData
                }))
            })
        } else {
            contactsData.splice(index, 1);
            this.setState(() => ({
                contactsData
            }))
        }
    }

    handleAddPoints() {
        this.setState({
            showList: true,
            isAdd: true
        })
    }

    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }

    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }

    closeContact(status, contact) {
        // console.log("=============status==============", status);
        // console.log("==============this.props.isAdd=============", this.props.isAdd);
        // console.log("===============contact============", contact);
        if (status === ADD) {
            console.log("=============add==============");
            console.log("==============this.props.isAdd=============", this.props.isAdd);
            const { contactsData } = this.state;
            contactsData.push(contact);
            if (this.props.isAdd) {
                this.setState({
                    contactsData,
                    showList: false,
                });
            } else {
                this.addContact(contactsData, () => {
                    this.setState({
                        contactsData,
                        showList: false,
                    });
                });
            }
        } else if (status === EDIT) {
            console.log("=============edit==============");
            console.log("==============this.props.isAdd=============", this.props.isAdd);
            const { contactsData } = this.state,
                index = contact.index;
            if (this.props.isAdd) {
                this.setState({
                    contactsData,
                    showList: false,
                });
            } else {
                this.updateContact(contact, () => {
                    contactsData[index] = contact;
                    this.setState({
                        contactsData,
                        showList: false,
                    });
                });
            }
        } else {
            console.log("=============nooooo==============");
            this.setState({
                showList: false,
            });
        }
    }

    getData() {
        return this.state.contactsData
    }

    addContact(contacts, callback) {
        const clientId = this.props.clientId;
        if (!clientId) return;
        const params = {
            contacts,
        };
        instance.post(BASE_URL + `common/clients/${clientId}/contacts`, params).then((res) => {
            console.log("add contact", res);
            this.showToast("Successfully added contact", "success");
            callback(res);
        }).catch((err) => {
            if (!err.response) {
                this.showToast("unknown error", "error");
            }
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    updateContact(obj, callback) {
        const params = {
            // related_parties: obj.related_parties,
            client_id: obj.client_id,
            relation: obj.relation,
        };
        instance.put(BASE_URL + `common/client/contacts/${obj.contact_id}`, params).then((res) => {
            console.log("update contact", res);
            this.showToast("Successfully modified contact", "success");
            callback(res);
        }).catch((err) => {
            if (!err.response) {
                this.showToast("unknown error", "error");
            }
            // const msg = err.response.data.message;
            this.showToast("error", "error");
        })
    }
    delContact(contactId, callback) {
        instance.delete(BASE_URL + `common/client/contacts/${contactId}`).then((res) => {
            console.log("del contact", res);
            this.showToast("Successfully deleted contact", "success");
            callback(res);
        }).catch((err) => {
            if (!err.response) {
                this.showToast("unknown error", "error");
            }
            // const msg = err.response.data.message;
            this.showToast("error", "error");
        })
    }
}

export default Contacts;